import { createActionGroup, props } from '@ngrx/store';

export const creativeSetActions = createActionGroup({
    source: 'CreativeSet',
    events: {
        loaded: props<{ creativeSetId: string }>()
    }
});
